"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// 货币数据上下文
var CurrencyContext = /*#__PURE__*/_react["default"].createContext({
  fromCurrencyCode: 'CNY',
  rateData: null
});

CurrencyContext.displayName = 'CurrencyContext';
var _default = CurrencyContext;
exports["default"] = _default;